export default __webpack_public_path__ + "static/media/survey.4ec38bb2.svg";